import { Link } from 'react-router-dom';
import { TemplatesData } from '../lib/TemplatesData';

const SelectTemplate = () => {
 

    return (
        <div className='h-full py-10 md:py-2'>
            <h1 className='text-center text-xl md:text-5xl font-semibold pt-10 '>
                Choose Your Perfect Resume Template
            </h1>
            <h2 className='text-center mx-auto w-[80%] md:w-full text-sm md:text-xl mt-3 text-muted-foreground'>Craft your professional story with our expertly designed templates</h2>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-x-24  content-center mt-4 mx-6 md:mx-20'>
                {TemplatesData.map((template,index) => {

                    const {id="", src = "" } = template;
                    return <div className='shadow-2xl rounded-lg relative group bg-white' >
                        <img src={src} alt="" className=' object-contain h-full w-full rounded-lg'  />
                        <div className='absolute top-0 flex justify-center items-center w-full h-full bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300  rounded-lg left-0'>
                            <Link to={`/resume-builder`} state={{
                                index: index,
                                id: id
                            }} className='w-full mx-5'>
                                <button onClick={()=> {
                                    localStorage.setItem("templateId",id)
                                }} className='w-full py-2 bg-white text-black hover:bg-gray-200 rounded-lg'>Use This Template</button>
                            </Link>
                        </div>
                    </div>
                })}

            </div>

        </div>
    )
}

export default SelectTemplate